import { combineReducers } from 'redux';

import appticker from '../appticker';
import roadblock from '../roadblock';
import myaccount from '../myaccount';
import modals from '../shared/modal';
import search from '../shared/search';
import popup from '../shared/Popup';
import sorts from '../shared/sorts';
import facets from '../shared/facets';
import request from '../shared/request';
import banner from '../shared/banner';
import counter from '../shared/counter';
import addressBook from '../../myaccount/reducers/addressBook';
import bannerInfo from '../../myaccount/reducers/bannerInfo';
import personalInfo from '../../myaccount/reducers/personalInfo';
import footer from '../shared/footer';
import loaders from '../shared/loaders';
import location from '../shared/location';
import httpError from '../shared/HTTPError';
import navigation from '../shared/navigation';
import seoMetaData from '../shared/seoMetaData';
import webMetaData from '../shared/webMetaData';
import HomeReducer from '../shared/HomeReducer';
import luxeTopNav from '../shared/luxeTopNav';
import RecentSearches from '../shared/recentSearch';
import mobileBottomNavReducer from './mobileBottomNavReducer';
import product from '../shared/product';
import productsAdditionalInfo from '../shared/productsAdditionalInfo';
import flags from '../shared/flags';
import bannerProducts from '../bannerProducts';
import myJioData from '../shared/myJioData';
import wishlist from '../../wishlist/reducers/wishlist';
import ratingsReducers from '../shared/ratings';
import fleekRootReducer from './../../fleek/reducers/fleekRootReducer';
import apiErrorReducer from '../shared/apiErrorReducer';
import membershipReducer from '../shared/membershipReducer';
import cacheData from '../shared/cacheData';
import minicart from '../shared/minicart';
import { apiCallReducer, dressToolFlagReducer, stepsReducer } from '../shared/braRecommendation';
import { miscellaneousReducer } from '../shared/miscellaneous';
import { rushAddressBarFlagReducer, rushDeliveryTypeReducer } from '../shared/ajioRush';
import ajioWalletData from '../../myaccount/reducers/ajioWalletData';
import ajioWalletDataBottomStrip from '../shared/ajioWalletDataBottomStrip';
import plpOnLanding from '../shared/plpOnLanding';
import variants from '../shared/variants';

const rootReducer = combineReducers({
  banner,
  footer,
  search,
  popup,
  sorts,
  facets,
  request,
  modals,
  loaders,
  counter,
  location,
  myaccount,
  appticker,
  roadblock,
  httpError,
  navigation,
  HomeReducer,
  luxeTopNav,
  seoMetaData,
  RecentSearches,
  metaData: webMetaData,
  product,
  productsAdditionalInfo,
  bottomNavList: mobileBottomNavReducer,
  flags,
  bannerInfo,
  personalInfo,
  bannerProducts,
  myJioData,
  wishlist,
  ratings: ratingsReducers,
  fleek:fleekRootReducer,
  membership: membershipReducer,
  cacheData,
  popup,
  apiErrors: apiErrorReducer,
  minicart,
  stepsReducer,
  apiCallReducer,
  dressToolFlagReducer,
  addressBook,
  miscellaneous: miscellaneousReducer,
  rushAddressBarFlagReducer,
  rushDeliveryTypeReducer,
  ajioWalletData,
  ajioWalletDataBottomStrip,
  plpOnLanding,
  variants
});

export default rootReducer;
